<h1 mat-dialog-title class="text-center pm-dialog-title">{{'Language.AddAddressText' | translate}}</h1>

<div mat-dialog-content class="contentt">
  <div class="entry-forms">
    <div class="row">
      <div class="col-md-6">
        <label class="f-label">{{'Language.AddressNameText' | translate }}</label>
        <mat-form-field class="full-width" appearance="outline">
          <input type="text" matInput name="addressName" [(ngModel)]="this.address_data.addressName"
            (ngModelChange)="btnEvent($event)">
        </mat-form-field>
      </div>
      <div class="col-md-6">
        <label class="f-label">{{'Language.CountryText' | translate }}</label>
        <!-- <mat-form-field class="full-width" appearance="outline">
          <input matInput name="countryName" readonly (click)="onOpenDropDown('country')"
            [(ngModel)]="this.address_data.countryName">
          <img src="./assets/images/cfl.svg" matSuffix alt="" class="me-2">
        </mat-form-field> -->

        <mat-form-field class="full-width"  appearance="outline">
          <!-- <input type="text" placeholder="Search Country Name" matInput [formControl]="myControl" [value]=''
            [matAutocomplete]="auto" [(ngModel)]="this.address_data.countryName">
          <mat-autocomplete #auto="matAutocomplete">
            <mat-option *ngFor="let option of filteredOptions | async" [value]="option.name"
              (onSelectionChange)="OnOptionSelected(option)">
              {{option.name}}
            </mat-option>
          </mat-autocomplete> -->


          <input type="text" placeholder="Search Country Name" matInput
          [(ngModel)]="this.address_data.countryName"  (click)="onOpenDropDown('country')"
         >
          <img src="./assets/images/cfl.svg" matSuffix alt="" class="me-2"  (click)="onOpenDropDown('country')">
        </mat-form-field>
      </div>
      <div class="col-md-6">
        <label class="f-label">{{'Language.Street/PoBoxNo.Text' | translate }}</label>
        <mat-form-field class="full-width" appearance="outline">
          <input type="text" matInput [(ngModel)]="this.address_data.street">
        </mat-form-field>
      </div>
      <div class="col-md-6">
        <label class="f-label">{{'Language.StreeNo.Text' | translate }}</label>
        <mat-form-field class="full-width" appearance="outline">
          <input type="text" matInput [(ngModel)]="this.address_data.streetNo">
        </mat-form-field>
      </div>
      <div class="col-md-6">
        <label class="f-label">{{'Language.CityText' | translate }}</label>
        <mat-form-field class="full-width" appearance="outline">
          <input type="text" matInput [(ngModel)]="this.address_data.city">
        </mat-form-field>
      </div>
      <div class="col-md-6">
        <label class="f-label">{{'Language.StateText' | translate }}</label>
        <mat-form-field class="full-width"  appearance="outline">
          <input type="text" readonly matInput [(ngModel)]="this.address_data.stateName"
          (click)="onOpenDropDown('state')"  >
          <img src="./assets/images/cfl.svg" (click)="onOpenDropDown('state')" matSuffix alt="" class="me-2">
        </mat-form-field>
      </div>
      <div class="col-md-6">
        <label class="f-label">{{'Language.ZipCodeText' | translate }}</label>
        <mat-form-field class="full-width" appearance="outline">
          <input type="text" matInput [(ngModel)]="this.address_data.zipCode">
        </mat-form-field>
      </div>
      <div class="col-md-6">
        <label class="f-label">{{'Language.GSTINText' | translate }}</label>
        <mat-form-field class="full-width" appearance="outline">
          <input type="text" matInput [(ngModel)]="this.address_data.gstin" maxlength="15">
        </mat-form-field>
      </div>
      <div class="col-md-6">
        <label class="f-label">{{'Language.GSTTypeText' | translate }}</label>
        <mat-form-field class="full-width" appearance="outline">
          <input type="text" matInput readonly [(ngModel)]="this.address_data.gstTypeName"
             (click)="onOpenDropDown('gsttype')">
          <img src="./assets/images/cfl.svg" matSuffix alt="" class="me-2"  (click)="onOpenDropDown('gsttype')">
        </mat-form-field>
      </div>
      <!-- <div class="col-md-6">
        <label class="f-label full-width">GSTIN Type</label>
        <mat-checkbox></mat-checkbox>
      </div> -->
      <div class="col-md-6" *ngIf="this.address_data.addressType=='bo_BillTo'">
        <!-- <mat-checkbox>Shipping Address</mat-checkbox> -->
        <mat-checkbox value="this.address_data.isBoolCopyToShipToAddressChecked"
          [checked]="this.address_data.isBoolCopyToShipToAddressChecked" (ngModelChange)="btnEvent($event)"
          [(ngModel)]="this.address_data.isBoolCopyToShipToAddressChecked" (change)="onChangeCopyCheckBox($event)">
          {{'Language.CopyToShipToAddressText' | translate }}

        </mat-checkbox>
      </div>
    </div>
  </div>
</div>
<div mat-dialog-actions [align]="'end'">
  <button mat-raised-button [mat-dialog-close]=false>{{'Language.CancelText' | translate}}</button>
  <button mat-raised-button color="primary" mat-dialog-close (click)="onSave()">{{'Language.AddText'| translate}}</button>
</div>